
import { controls } from "../controls";

const ms451 = {
  label: "Promissory Note",
  pageLabel: "Promissory Note",
  starting: true,
  url: "ms101",
  pageType: "history",
  formActions: { edit: { allow: true } },
  formTabs: {
    allTabs: [
      {
        label: "General",
        uid: "general",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "Branch", width: "col-sm-1" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch", isRequired: true, isReadOnly: true, star: true }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-3" }),

    ...controls.displayText({ tab: "filter", label: "PACS ID", width: "col-sm-1" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "pacs_id", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3" }),

    ...controls.displayText({ tab: "filter", label: "Season ID", width: "col-sm-1" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "season_id", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3" }),

    ...controls.displayText({ tab: "filter", label: "Crop Type", width: "col-sm-1" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "crop_type", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3" }),

    ...controls.displayText({ tab: "filter", label: "Crop Name", width: "col-sm-1" }),
    ...controls.crop({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "crop_code_display", width: "col-sm-3" }),

    ...controls.displayText({ tab: "filter", label: "Product", width: "col-sm-1" }),
    ...controls.product({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({
      tab: "filter", data: "product_code_display", width: "col-sm-3"
    }),

    // ...controls.Multibutton({
    //   name: "cdflag", 
    //   width: "col-sm-3",
    //   Bcolor: "success",
    //   style: { padding: 0 },
    //   options: [
    //     { label: "Samath", value: "samarth", width:"col-sm-4"},
    //     { label: "Asamath", value: "asamarth" ,width:"col-sm-4"},
    //   ]
    // }),

    ...controls.displayText({ style: { textAlign: 'right' }, label: "Amount", width: "col-sm-1" }),
    ...controls.numtoword({
      convertedTo: "entered_amount_text",
      name: "entered_amount",
      width: "col-sm-2"
    }),
    ...controls.showData({
      data: "entered_amount_text", name: "entered_amount_text", width: "col-sm-3", style: { fontSize: 14 },
    }),

  ],
  form: [
    ...controls.displayText({ tab: "general", label: "Branch", width: "col-sm-1" }),
    ...controls.branch({ tab: "general", defaultValue: "assigned_branch", isRequired: true, isReadOnly: true, star: true }),
    ...controls.showData({ tab: "general", data: "branch_display", name: "branch_display", width: "col-sm-3" }),

    ...controls.displayText({ tab: "general", label: "PACS ID", width: "col-sm-1" }),
    ...controls.text({ tab: "general", placeHolder: "", name: "pacs_id", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "general", star: true, label: "As on Date", width: "col-sm-1" }),
    ...controls.magicDate({ tab: "general", name: "as_on_date", width: "col-sm-2", dateType: "ontype", isRequired: true, default: "sessiondate" }),

    ...controls.displayText({ tab: "general", label: "Season ID", width: "col-sm-1" }),
    ...controls.text({ tab: "general", placeHolder: "", name: "season_id", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-3" }),

    ...controls.displayText({ tab: "general", label: "Crop Type", width: "col-sm-1" }),
    ...controls.text({ tab: "general", placeHolder: "", name: "crop_type", width: "col-sm-2" }),
    // ...controls.displayText({ tab: "general", label: "", width: "col-sm-3" }),

    ...controls.displayText({ tab: "general", label: "Crop Name", width: "col-sm-1" }),
    ...controls.text({ tab: "general", placeHolder: "", name: "crop_name", width: "col-sm-2" }),
    // ...controls.displayText({ tab: "general", label: "", width: "col-sm-3" }),

    ...controls.displayText({ tab: "general", label: "Product", width: "col-sm-1" }),
    ...controls.product({ tab: "general", width: "col-sm-2" }),
    ...controls.showData({
      tab: "general", data: "product_code_display", width: "col-sm-3"
    }),

    // ...controls.Multibutton({
    //   name: "cdflag", 
    //   width: "col-sm-3",
    //   Bcolor: "success",
    //   style: { padding: 0 },
    //   options: [
    //     { label: "Samath", value: "samarth", width:"col-sm-4"},
    //     { label: "Asamath", value: "asamarth" ,width:"col-sm-4"},
    //   ]
    // }),

    ...controls.displayText({ style: { textAlign: 'right' }, label: "Amount", width: "col-sm-1" }),
    ...controls.numtoword({
      convertedTo: "entered_amount_text",
      name: "entered_amount",
      width: "col-sm-2"
    }),
    ...controls.showData({
      data: "entered_amount_text", name: "entered_amount_text", width: "col-sm-3", style: { fontSize: 14 },
    }),
  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    // clickable: true,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Branch",
        accessor: "branch_display",
      },
      {
        Header: "PACS ID",
        accessor: "customer_number",
      },
      {
        Header: "Season",
        accessor: "customer_type",

      },
      {
        Header: "Crop Type",
        accessor: "risk_category",

      },
      {
        Header: "Crop Name",
        accessor: "tds_flag",

      },
      {
        Header: "Amount",
        accessor: "title",

      },
      {
        Header: "GL",
        accessor: "full_name",
        show: false
      }
    ]
  }
};

export default ms451;
